var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresciptionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75008 17.0832L17.0834 8.74984C17.4728 8.36823 17.7827 7.91322 17.9951 7.41111C18.2076 6.90899 18.3184 6.36975 18.3212 5.82454C18.3239 5.27934 18.2186 4.739 18.0112 4.23477C17.8038 3.73054 17.4986 3.27242 17.113 2.8869C16.7275 2.50137 16.2694 2.1961 15.7652 1.98873C15.2609 1.78136 14.7206 1.67601 14.1754 1.67876C13.6302 1.68152 13.0909 1.79232 12.5888 2.00478C12.0867 2.21723 11.6317 2.52711 11.2501 2.91651L2.91675 11.2498C2.52736 11.6314 2.21747 12.0865 2.00502 12.5886C1.79257 13.0907 1.68176 13.6299 1.67901 14.1751C1.67625 14.7203 1.78161 15.2607 1.98898 15.7649C2.19635 16.2691 2.50162 16.7273 2.88714 17.1128C3.27266 17.4983 3.73078 17.8036 4.23501 18.0109C4.73925 18.2183 5.27959 18.3237 5.82479 18.3209C6.36999 18.3182 6.90924 18.2074 7.41135 17.9949C7.91346 17.7825 8.36848 17.4726 8.75008 17.0832Z",
    stroke: "#DBEAFE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08325 7.08301L12.9166 12.9163",
    stroke: "#DBEAFE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresciptionIcon);
export default __webpack_public_path__ + "static/media/presciption-icon.4181c85c5a8e97b406d696b056f640b3.svg";
export { ForwardRef as ReactComponent };